module.exports = __webpack_public_path__ + "static/media/gp.de8a046a.svg";